import styled from "styled-components";
import { colors } from './../../variables';

export const UploadWrapper = styled.div`
  width: 400px;
  background-color: transparent;
  border-radius: 0px;
  position: relative;
  margin-top: 80px;
  z-index: 30;
  left: 50%;
  margin-left: -200px;
  @media (max-width: 991px){
    position: relative;
    border: 0px;
    margin: 0 auto;
    margin-top: 80px;
    width: auto;
    left: inherit;
    background-color: transparent;
  }
  @media (max-width: 767px){
    position: relative;
  }
`;

export const UploadContent = styled.div`
  padding: 40px 20px;
  color: #4a4a4a;
  text-align: center;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
  @media (max-width: 767px){
    padding: 20px;
    padding-bottom: 50px;
  }
`;

export const UploadGif = styled.div`
  text-align: center;
  img{
    width: 120px;
    height: auto;
  }
`;

export const UploadLoader = styled.div`
  font-size: 70px;
  color: #4a4a4a;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
  sup{
    font-size: 20px;
  }
`;

export const UploadLoaderText = styled.div`
  font-size: 14px;
  color: #4a4a4a;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
  sup{
    font-size: 20px;
  }
`;

export const UploadTitle = styled.div`

  margin-top: 20px;
  font-size: 32px;
  line-height: 32px;
  color: #4a4a4a;
  text-align: center;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
`;

export const UploadMessage = styled.div`
  text-transform: normal;
  font-size: 12px;
  margin-top: 20px;
  color: #4a4a4a;
  @media (max-width: 991px){
    color: #4a4a4a;
  }
`;